module.exports = __webpack_public_path__ + "img/2015.7a247e6c.png";